 
import React, {useContext} from 'react';
import {BridleContext} from './../BridleContextProvider';
import {getAttributesGroupedInDisplayOrder, getSortOrder, orderMap} from '../HelperFunctions';
import Toolbar from '../components/Toolbar';
import SectionInfo from './../components/SectionInfo';
import Buttons from './../components/Buttons';
import Page from '../components/Page';

const Cheek = () => {
    const {products, options} = useContext(BridleContext);
    const pieces = getSortOrder(products, orderMap.Cheek);
    const productId = options.Cheek.productId;
    const attributesInOrder = getAttributesGroupedInDisplayOrder(pieces.attributeValues);

    return (
        <div className="bridle-page-content">
            <Toolbar pageName="Cheek Piece" />
            <SectionInfo section="Cheek Piece" page="4" />
            <Page
                attributes={attributesInOrder}
                pageName="Cheek"
                pieces={pieces}
                productId={productId}
                sizeGuide="cheekpiece"
            />
            <Buttons back="/browband" next="/noseband" disableButton={productId === ''} />
        </div>
    );
};

export default Cheek;
